<template>
  <div class="wrapper">
    <div style="margin-bottom:20px;">
      <el-button  v-auth="'sys:gateWay:add'" @click="handleEdit('',0)" type="primary" icon="el-icon-plus">{{$t('common.addNew')}}</el-button>
    </div>
    <el-table border v-loading="loading"  :data="gateList" style="width: 100%">
      <el-table-column :label="$t('common.date')" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.createDate }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('gateWay.programId')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.applicationId }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('gateWay.programName')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.applicationName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('gateWay.predicates')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.predicates }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('gateWay.gateUri')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.uri }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.handle')">
        <template slot-scope="scope">
          <el-button size="mini" v-auth="'sys:gateWay:edit'" @click="handleEdit(scope.row,1)">{{$t('common.edit')}}</el-button>
          <el-button size="mini" v-auth="'sys:gateWay:delete'" type="danger" @click="handleDelete(scope.$index, scope.row)">
            {{$t('common.delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="showEditBox">
      <el-form :model="form">
        <el-form-item :label="$t('gateWay.programId')" prop="applicationId" :label-width="formLabelWidth">
          <el-input v-model="form.applicationId" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('gateWay.programName')" prop="applicationName" :label-width="formLabelWidth">
          <el-input v-model="form.applicationName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('gateWay.gateUri')" prop="uri" :label-width="formLabelWidth">
          <el-input v-model="form.uri" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('gateWay.predicates')" prop="predicates" :label-width="formLabelWidth">
          <el-input v-model="form.predicates" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditBox = false">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="submitData">{{$t('common.ok')}}</el-button>
      </div>
    </el-dialog>
    <div style="margin-top:20px;text-align:right">
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="totalSize">
    </el-pagination>
    </div>
  </div>
</template>

<script>
import { gatewayList,editgatewayList,addgatewayList,delgatewayList } from "@/api/sys/gateway";
import { Message ,MessageBox} from "element-ui";
export default {
  data() {
    return {
      titleName: this.$t("common.edit"),
      gateList: [],
      showEditBox: false,
      changeType: 1,
      currentPage:1,
      pageSize:10,
      totalSize:0,
      formLabelWidth: "120px",
      loading:false,
      form: {
        applicationId: "",
        applicationName: "",
        id: "",
        predicates: "",
        uri: ""
      }
    };
  },
  mounted() {
    this.getGatewayList();
  },
  methods: {
    getGatewayList() {
      gatewayList().then(res => {
        this.gateList = res.result.list;
        this.totalSize = res.result.total
        this.loading = false
      });
    },
    handleEdit(row, type) {
        let updateObject;
      updateObject = Object.assign({},row);
      this.changeType = type;
      if (this.changeType == 1) {
        this.form = row;
        this.titleName = this.$t("common.edit")
      }else{
        for (let key in this.form) {
          this.form[key] = "";
        }
        this.titleName = this.$t("common.addNew")
      }
      this.showEditBox = true;
    },
    handleDelete(index, row) {
      this.$confirm('是否删除网关', '提示', {
          confirmButtonText: this.$t("common.ok"),
          cancelButtonText: this.$t("common.cancel"),
          type: 'warning',
           beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delgatewayList(row.id).then(res => {
              if (res.code == 0) {
                this.getGatewayList()
              }
            });
            done();
          } else {
            done();
          }
        }
        }).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('common.conDelete')
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
     handleSizeChange(val){
     this.pageSize = val;
     this.getGatewayList()
    },
    handleCurrentChange(val){
      this.currentPage = val;
       this.getGatewayList()
    },
    submitData(){
      if (this.changeType == 1) {

        editgatewayList(this.form).then(res => {
            if (res.code == 0) {
              Message({
                message: this.$t('common.changeSu'),
                type: "success"
              });
            }
             this.getGatewayList();

        });
      } else {

        addgatewayList(this.form).then(res => {

          if (res.code == 0) {
            Message({
              message: this.$t('common.addSu'),
              type: "success"
            });
          }
           this.getGatewayList();
        });
      }

      this.showEditBox = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  margin: 50px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  padding: 20px;
}
</style>
